import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#header-service-a)">
        <path
          fill="url(#header-service-b)"
          d="M18.464 6.36h-.163a8.956 8.956 0 0 0-1.98-2.987A8.956 8.956 0 0 0 9.968.741a8.957 8.957 0 0 0-6.355 2.632 8.957 8.957 0 0 0-1.98 2.987h-.065a.979.979 0 0 0-.979.98v2.662c0 .54.439.979.98.979h.92c.54 0 .979-.438.979-.979V7.339a.979.979 0 0 0-.587-.897 7.823 7.823 0 0 1 7.087-4.526c3.15 0 5.87 1.874 7.105 4.566a.979.979 0 0 0-.507.857v2.663c0 .54.438.979.98.979h.135a7.796 7.796 0 0 1-6.112 6.396 1.576 1.576 0 1 0-.315 1.247 8.94 8.94 0 0 0 5.205-2.68 8.938 8.938 0 0 0 2.422-5.055.979.979 0 0 0 .563-.887V7.339a.98.98 0 0 0-.979-.979Z"
        />
        <g filter="url(#header-service-c)">
          <path
            fill="url(#header-service-d)"
            d="M16.154 9.65a6.109 6.109 0 1 0-12.217 0 6.109 6.109 0 0 0 12.217 0ZM7.03 11.098l.003-.117h5.947l.002.117a2.976 2.976 0 1 1-5.952 0Z"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="header-service-b"
          x1={10.016}
          x2={10.016}
          y1={0.741}
          y2={19.224}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#27E28B" />
          <stop offset={1} stopColor="#13CBCB" />
        </linearGradient>
        <linearGradient
          id="header-service-d"
          x1={10.045}
          x2={10.045}
          y1={3.541}
          y2={15.758}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#27E28B" />
          <stop offset={1} stopColor="#13CBCB" />
        </linearGradient>
        <clipPath id="header-service-a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
        <filter
          id="header-service-c"
          width={16.218}
          height={16.218}
          x={1.937}
          y={2.541}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11594_1266"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_11594_1266"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
